import { create } from "zustand";

const ActivityMessaging = create((set) => ({
  messagingId: "",
  setMessageId: (_id) => {
    set(() => ({
      messagingId: _id,
    }));
  },
}));

export default ActivityMessaging;
